{
    "help": {
        "button": {
            "tooltip": "AI helper",
            "label": "Ask AI"
        },
        "title": "Ask AI",
        "reconnecting": "Reconnecting…",
        "thinking": "Thinking…",
        "noMessagesYet": "Hi! I'm your VinceLive help assistant.\nAsk me anything about how VinceLive works — features, workflows, or where to find what you need — and I'll point you to the right answers and docs.",
        "typeYourMessage": "Type your message…",
        "collapse": "Close",
        "choice": {
            "placeholder": "Select an option",
            "confirm": "Confirm"
        },
        "reader": {
            "back": "Back",
            "fullscreen": "Fullscreen",
            "exitFullscreen": "Exit fullscreen",
            "close": "Close",
            "openInApp": "Open in app",
            "loading": "Loading…",
            "error": "Couldn't load this document.",
            "retry": "Try again"
        },
        "context": {
            "title": "Adjust answers",
            "optionsError": "Couldn't load department options.",
            "industry": "Industry",
            "department": "Team",
            "notSet": "Not set",
            "answers": "Answers",
            "thisConversation": "This conversation",
            "aboutYou": "About you",
            "aboutYouHint": "Set once. Used to pick examples and vocabulary.",
            "level": "Your skill level",
            "length": "Answer length",
            "done": "Apply",
            "appliesNext": "Applies from your next question",
            "familiarityQuestion": "How familiar are you with Vince Platform?",
            "familiarityHint": "Adjust how much detail the AI provides.",
            "lengthQuestion": "How long should answers be?",
            "lengthHint": "Choose brief or fully explained answers.",
            "fullRestricted": "Full answers are not available for your account yet.",
            "departmentQuestion": "Which department are you in?",
            "departmentHint": "Helps tailor examples and links to your team.",
            "industryQuestion": "Which industry are you in?",
            "industryHint": "Set by your organization."
        },
        "notice": {
            "busy": "Help is busy. Retrying…",
            "paused": "Chat paused. Tap to resume.",
            "badFrame": "Connection error. Reconnecting…",
            "connectFailed": "Couldn't start Help. Try again.",
            "resume": "Resume",
            "retry": "Try again",
            "turnInterrupted": "Your last message may not have gone through — please send it again."
        },
        "displayMode": {
            "dock": "Dock as sidebar",
            "float": "Float over content"
        },
        "level": {
            "beginner": "Beginner",
            "beginnerHint": "Assumes no VinceLive experience",
            "beginnerRadioLabel": "Just starting",
            "beginnerRadioHint": "Step-by-step explanations.",
            "intermediate": "Intermediate",
            "intermediateHint": "Skips the basics",
            "intermediateRadioLabel": "Some experience",
            "intermediateRadioHint": "Quick answers, more details if you ask.",
            "advanced": "Advanced",
            "advancedHint": "Straight to the setting",
            "advancedRadioLabel": "Pretty confident",
            "advancedRadioHint": "Skip the basics, but flag anything new.",
            "expert": "Expert",
            "expertHint": "Terse, no walkthrough",
            "expertRadioLabel": "I use this all the time",
            "expertRadioHint": "Just the facts, skips the basics."
        },
        "length": {
            "brief": "Brief",
            "full": "Full"
        },
        "send": "Send",
        "setup": {
            "title": "Set up your AI Helper",
            "hint": "Tell us your experience level and department so answers are tailored from the start.",
            "skip": "Not now",
            "save": "Save"
        }
    },
    "ai": {
        "usage": {
            "emptyState": "No usage recorded yet.",
            "totalTokens": "Total tokens",
            "estimatedCost": "Estimated cost",
            "sessions": "Sessions",
            "inputTokens": "Input tokens",
            "outputTokens": "Output tokens",
            "cacheCreationTokens": "Cache write tokens",
            "cacheReadTokens": "Cache read tokens",
            "tokenBreakdown": "Token breakdown",
            "fundingBreakdown": "Funding breakdown",
            "yourConnection": "Your connection",
            "estimateDisclaimer": "Token counts are exact. Dollar amounts are estimates and may differ from actual billing.",
            "vinceAi": "Vince AI",
            "estimateHint": "Running total for this build session. The dollar figure is an estimate.",
            "tokensValue": "{value} tokens",
            "estimateSuffix": "(est.)",
            "noUsageRecorded": "No usage recorded for this session.",
            "vinceProvided": "Vince-provided",
            "unknownConnection": "Unknown connection",
            "byConnection": "By connection",
            "sessionsCount": "{count} sessions",
            "unpricedUsage": "Some usage could not be priced",
            "permissionDenied": "You do not have permission to view this usage.",
        "loadError": "Usage could not be loaded. Please try again.",
        "exactHint": "Running total for this build session. The dollar amount is exact.",
        "billedCost": "Billed cost",
        "legacyEstimate": "Estimated total including earlier usage: {value}",
        "billedExcludesHistory": "Excludes earlier usage recorded before exact pricing.",
        "exactDisclaimer": "Token counts and dollar amounts are exact as billed."
        }
    },
    "foundation": {
        "resource": {
            "apiclient": "API Client",
            "connection": "Connection",
            "dashboard": "Dashboard",
            "environment": "Environment",
            "user": "User",
            "workflow": "Workflow",
            "group": "Group",
            "variable": "Variable",
            "webhook": "Webhook",
            "metadata": "Metadata",
            "role": "Role",
            "gateway": "Gateway"
        }
    },
    "core": {
        "app": {
            "ai-apps": "AI Apps",
            "customtables": "Custom Tables",
            "fnd": "Foundation",
            "tenantManagement": "Tenant Management"
        }
    },
    "addon": {
        "app": {
            "kanban": "Kanban",
            "campaign": "Campaign",
            "impexHelper": "Impex Helper",
            "mdbreadmiHelper": "MDB Readmi Helper",
            "miTest": "MI Test",
            "m3PrintoutConfig": "M3 Printout Config",
            "vincePricer": "Vince Pricer",
            "cugexHelper": "CUGEX Helper",
            "isLantmannen": "Is Lantmannen",
            "spykar": "Spykar",
            "eshopbox": "Eshopbox",
            "scannerPickPack": "Scanner Pick Pack",
            "pickPack": "Pick Pack",
            "contractManagement": "Contract Management",
            "aiApps": "AI Apps",
            "aiWorkflows": "AI Workflows"
        },
        "resource": {
            "aiWorkflow": "Workflow"
        }
    },
    "wildcard": {
        "option": "All",
        "fullAccess": "Full access"
    },
    "action": {
        "read": "Read",
        "run": "Run",
        "write": "Write",
        "deploy": "Deploy",
        "deny": "Deny"
    },
    "customTable": {
        "resource": {
            "configuration": "Configuration",
            "data": "Data"
        }
    },
    "storageItemType": {
        "FILE": {
            "label": "File"
        },
        "FOLDER": {
            "label": "Folder"
        }
    },
    "storageService": {
        "LOCAL": {
            "label": "Local file"
        },
        "ONEDRIVE": {
            "label": "Your OneDrive"
        },
        "SHAREPOINT": {
            "label": "Sharepoint"
        }
    },
    "fileSelector": {
        "oneDriveItems": "Your personal drives",
        "sharedWithMe": "Shared with me",
        "myFiles": "My files",
        "browse": "Browse",
        "select": "Select",
        "selectFile": "Select file",
        "dragFiles": "Drag and drop files to here",
        "sites": "Sites",
        "selectSite": "Select site to see available items",
        "createFile": "New excel file",
        "fileName": "New excel file name",
        "created": "Created",
        "modified": "Modified",
        "name": "Name",
        "microsoftThrottled": "Microsoft temporarily limited SharePoint requests. Wait a moment and try again.",
        "sitesLoadFailed": "Failed to load SharePoint sites.",
        "itemsLoadFailed": "Failed to load SharePoint files.",
        "retry": "Retry"
    },
    "common": {
        "logicalOperators": {
            "AND": "AND",
            "OR": "OR"
        },
        "validation": {
            "required": "Field is mandatory",
            "notNumber": "Number value required",
            "tooLong": "Max length: {maxLength} characters"
        },
        "actions": {
            "done": "Done",
            "advanced": "Advanced settings",
            "back": "Back",
            "cancel": "Cancel",
            "clear": "Clear",
            "close": "Close",
            "copy": "Copy",
            "create": "Create",
            "delete": "Delete",
            "edit": "Edit",
            "disable": "Disable",
            "next": "Next",
            "no": "No",
            "ok": "Ok",
            "previous": "Previous",
            "reset": "Reset",
            "save": "Save",
            "update": "Update",
            "view": "View",
            "yes": "Yes",
            "yesDelete": "Yes, delete",
            "apply": "Apply",
            "activate": "Activate",
            "deactivate": "Deactivate",
            "goHomePage": "Go back to homepage",
            "add": "Add",
            "upload": "Upload",
            "download": "Download",
            "execute": "Execute",
            "import": "Import",
            "startImporting": "Start Importing",
            "selectAll": "Select All",
            "showSelected": "Show Selected",
            "manage": "Manage"
        },
        "system": "System",
        "label": "Label",
        "labels": "Labels",
        "actionsLabel": "Actions",
        "noPermission": "No permission to access ",
        "active": "Active",
        "activated": "Active",
        "deactivated": "Deactivated",
        "address": "Address",
        "alias": "Alias",
        "confirmation": "Confirmation",
        "description": "Description",
        "details": "Details",
        "download": "Download",
        "email": "Email",
        "tenantPermissions": "Tenant Permissions",
        "firstName": "First Name",
        "surname": "Surname",
        "fullName": "Full Name",
        "in": "in",
        "lastName": "Last Name",
        "left": "Left",
        "loading": "Loading",
        "milliseconds": "ms.",
        "name": "Name",
        "notFound": "Not found",
        "notFoundAbbreviation": "NF",
        "of": "of",
        "operation": {
            "EqualTo": "Equal to",
            "GreaterThan": "Greater than",
            "GreaterThanEqualTo": "Greater than or equal to",
            "LessThan": "Less than",
            "LessThanEqualTo": "Less than or equal to",
            "NotEqualTo": "Not equal to"
        },
        "password": "Password",
        "permissions": "Permissions",
        "phone": "Phone",
        "primary": "PRIMARY",
        "right": "Right",
        "roles": "Roles",
        "search": "Search",
        "searchPlaceholder": "Type to search",
        "texts": {
            "item": "item",
            "selected": "selected",
            "select": "Select"
        },
        "tags": "Tags",
        "success": "Success",
        "noRoles": "No roles assigned"
    },
    "comparison": {
        "equal": "Equal (=)",
        "greaterThan": "Greater than (>)",
        "greaterThanInclusive": "Greater than equal (>=)",
        "isBlank": "Is blank (=)",
        "isNotBlank": "Is not blank (!=)",
        "lessThan": "Less than (<)",
        "lessThanInclusive": "Less than equal (<=)",
        "notEqual": "Not equal (!=)",
        "stringContains": "String contains",
        "stringNotContains": "String not contains",
        "contains": "Has",
        "notContains": "Has not"
    },
    "dataTypes": {
        "DATE": "Date",
        "NUMERIC": "Number",
        "STRING": "Text",
        "BOOLEAN": "Boolean"
    },
    "environments": {
        "code": "Environment Id in VXL Live",
        "deleteConfirmation": "Do you want to delete {environmentName}?",
        "descriptionRequired": "Environment description is required",
        "environmentActions": {
            "deleteEnvironment": {
                "title": "Confirm delete"
            }
        },
        "idRequired": "Environment Id is required",
        "messages": {
            "deleteSuccess": "Environment deleted successfully!",
            "cannotDeleteEnvironmentInConnection": "Cannot be deleted, Environment exists in a connection",
            "codeFormat": "Code accepts 1-4 letters (A-Z). Example: TEST, PROD",
            "environmentNameExists": "Environment {environmentName} already exists!",
            "errorOccurred": "Error occurred",
            "success": "Environment saved successfully!"
        },
        "nameRequired": "Environment name is required",
        "newEnvironment": "New Environment",
        "selectColor": "Select a Color",
        "theme": "Theme",
        "title": "Environments"
    },
    "connections": {
        "port": "Port",
        "m3Name": "M3 Name",
        "clientId": "Client ID",
        "clientSecret": "Client Secret",
        "autofillDetails": "Autofill from File",
        "uploadFile": "Upload file",
        "authenticationType": "Authentication Type",
        "importAPIs": "Import API's",
        "selectPrograms": "Select Programs",
        "bulkImport": "Bulk Import API's",
        "bulkImportDescription": "This will import all API's from the selected environment",
        "accessKey": "Access Key",
        "authHeaderName": "Authorization header name",
        "messages": {
            "confirmDeleteHeader": "Delete Connection",
            "confirmDeleteMessage": "Are you sure you want to delete this connection?",
            "confirmCertificateIssueHeader": "Issue Certificate",
            "confirmCertificateIssueMessage": "Are you sure you want to issue certificate for this connection?",
            "confirmCertificateRevokeHeader": "Revoke Certificate",
            "confirmCertificateRevokeMessage": "Are you sure you want to revoke certificate for this connection?",
            "saveSuccess": "Connection Saved Successfully",
            "deleteSuccess": "Connection Deleted Successfully",
            "validateSuccess": "Connection Validated Successfully",
            "certificate": "Certificate",
            "certificateIssueSuccess": "Certificate Issued Successfully",
            "certificateRevokeSuccess": "Certificate has been revoked successfully",
            "mandatoryField": "This field is mandatory",
            "cannotDelete": "This connection cannot be deleted as it's linked to one or more workflows",
            "invalidApis": "Invalid Program: {apiNames}",
            "importApiSuccessMessage": "Imported API's successfully",
            "importApiPartialSuccess": "Programs imported successfully, except: {apiNames}",
            "importApiErrorMessage": "Could not import API's.",
            "bulkImportApiError": "Could not start bulk API import.",
            "loadApiProgramsError": "Could not load API programs for this connection.",
            "loadConnectionForImportError": "Could not load the selected connection.",
            "errorWithReason": "{message} Reason: {reason}",
            "confirmBulkImportMessageTitle": "Confirm bulk import all API's",
            "confirmBulkImportMessage": "Bulk import will import all the API's from the selected environment and may take few minutes to complete the process. The status can be seen in the notification panel. Do you want to continue?",
            "systemWorkflowMissingError": "Unable to find the system workflow: {workflowName}",
            "apiClientMissingError": "Unable to find the API Client: {apiClientName}",
            "bulkImportStartedMessage": "Bulk import API has been initiated, You can check the status in the notifications panel",
            "environmentAlreadyConnectedError": "A connection with type {system} already exists in the {environment} environment!",
            "certificateIgnoredMessage": "'Use proxy' is enabled, the certificate will be ignored."
        },
        "certificate": {
            "title": "MTLS Certificate",
            "VinceLiveCertificate": "Use Vince Live Certificate",
            "CustomCertificate": "Use Custom Certificate",
            "label": "Certificate",
            "privateKey": "Private Key",
            "VLCertificatePlaceholder": "Certificate from Vince Live",
            "CustomCertificatePlaceholder": "Enter certificate or upload file below",
            "CustomPrivateKeyPlaceholder": "Enter private key or upload file below",
            "fileWarningMessage": "File must be OpenSSL format",
            "changePrivateKey": "Change Private Key File",
            "changeCertificate": "Change Certificate File",
            "privateKeyLoaded": "✓ Private key loaded ({length} characters)",
            "certificateLoaded": "✓ Certificate loaded ({length} characters)",
            "certificateDate": "Certificate Date",
            "updateCertificate": "Update Certificate"
        },
        "connectivity": "Connectivity",
        "security": "Security",
        "details": "Details"
    },
    "header": {
        "apiClients": "API Clients",
        "roles": "Roles",
        "users": "Users",
        "connections": "Connections",
        "tenants": "Tenants"
    },
    "notifications": {
        "noNotifications": "No new notifications",
        "announcement": "Announcement",
        "title": "Notifications",
        "clearAll": "Clear All",
        "workflowSuccessful": "Workflow run successful",
        "workflowFailed": "Workflow failed",
        "acknowledge": "Acknowledge notification",
        "customTables": {
            "header": "Table Indexing Error",
            "indexError": "Indexing failed for table \"{tableName}\"",
            "toastSummary": "Table Indexing Error",
            "toastDetailWithReason": "Table: \"{tableName}\"\nKey(s): {keys}\n\nReason: {reason}",
            "toastDetail": "Table: \"{tableName}\"\nKey(s): {keys}\n\nIndexing failed",
            "viewTable": "View table",
            "unknownError": "Unknown error"
        }
    },
    "home": {
        "greeting": {
            "morning": "Good morning",
            "afternoon": "Good afternoon",
            "evening": "Good evening"
        },
        "tenantLabel": "Tenant:",
        "welcomeMessage": "Welcome to the Vince Platform.\nCreate, automate, and manage your work in one place — from building apps and workflows to structuring data in tables and handling administration with confidence. Love from Vince Team 🧡\nIf you still miss the old version, you can access it for a limited period by using https://{tenantAlias}.old.vince.live",
        "logoAlt": "Vince logo",
        "cards": {
            "feedback": {
                "title": "Give us feedback",
                "content": "We want to hear from you!\nYour input helps shape the future of Vince. Found a bug? Have a great idea? Want to tell us what works, or what doesn't? Let us know!",
                "buttonLabel": "Give us Feedback"
            },
            "documentation": {
                "title": "Documentation",
                "content": "Everything you need — all in one place.\nWhether you're new to Vince or a power user, our docs are here to help. Browse how-tos, feature guides, setup tips, and more.\n\nDive into the knowledge base.",
                "buttonLabel": "Documentation"
            },
            "releaseNotes": {
                "title": "Release notes",
                "content": "Stay informed about the latest features, improvements, and fixes. We keep our release notes clean and simple — so you can spend less time reading and more time building.\nWe regularly ship new features, enhancements, and bug fixes.\n\nCheck out the full change log.",
                "buttonLabel": "View Release Notes"
            },
            "news": {
                "title": "News from Vince",
                "content": "What’s happening at Vince?\nStay updated with product announcements, behind-the-scenes insights, and tips from our team. We’re building in the open — and you’re invited.\n\nCatch the latest highlights.",
                "buttonLabel": "Visit Vince"
            }
        }
    },
    "menus": {
        "administration": "Administration",
        "home": "Home",
        "info": "Info",
        "apps": "Apps",
        "settings": "Settings",
        "accessManagement": "Access Management",
        "reports": "Reports",
        "aiSettings": "AI Management",
        "workflowSettings": "Workflow Settings",
        "workflowManagement": "Workflow Management",
        "external": "Help & Resources",
        "integrations": "Integrations",
        "subMenus": {
            "users": "Users",
            "roles": "Roles",
            "apiClients": "API-Clients",
            "tenants": "Tenants",
            "accessManagement": "Access Management",
            "auditLog": "Audit log",
            "fb": "POC - Form builder",
            "companyManagement": "Company Management",
            "connections": "Connections",
            "documentation": "Documentation",
            "environments": "Environments",
            "groups": "Groups",
            "latestUpdates": "Latest Updates",
            "logOut": "Log out",
            "schedules": "Schedules",
            "support": "Support",
            "tableManagement": "Tables",
            "userProfile": "My profile",
            "variables": "Variables",
            "webhooks": "Webhooks",
            "workflowStatistics": "Workflow statistics",
            "workflowMonitoring": "Workflow Monitoring",
            "addConnection": "Add Connection",
            "editConnection": "Edit Connection",
            "newConnection": "New Connection",
            "manageEnvironments": "Manage Environments",
            "apps": {
                "clickAndCollect": "Click and Collect",
                "campaign": "Campaign",
                "impexHelper": "Impex Helper",
                "mdbreadHelper": "MDBread Helper",
                "miTest": "MI Test",
                "m3PrintoutConfig": "M3 Printout Config",
                "vincePricer": "Vince Pricer",
                "cugexHelper": "CUGEX Helper",
                "lantmannenMaskin": "Lantmannen Maskin",
                "spykarChannelPlan": "Spykar Channel Plan",
                "eshopbox": "Eshopbox",
                "scannerPickPack": "Scanner Pick Pack",
                "pickPack": "Pick Pack",
                "contractManagement": "Contract Management"
            }
        },
        "workflows": "Workflows"
    },
    "profile": {
        "dateFormat": "Date format",
        "defaultDashboard": "Default dashboard",
        "languagePreference": "Language",
        "messages": {
            "error": "Could not save preferences!",
            "success": "Preferences saved successfully!",
            "nameUpdatedSuccess": "Name updated successfully!"
        },
        "numberPerPage": "Number of records in tables",
        "preferences": "Preferences",
        "timeFormat": "Time format",
        "userProfile": "Profile Settings",
        "cookieConsent": {
            "title": "Cookie Consent",
            "necessary": "Necessary",
            "statistics": "Statistics",
            "description1": "Some of our cookies are essential for the application to function and cannot be switched off in our systems. They are usually set in response to actions made by you, such as logging in, filling out forms, or setting your privacy preferences.",
            "description2": "In order to create solutions for an application that is as user-friendly as possible, we use the analytics tool Posthog. With the help of Posthog, we can collect data and analyze how Vince apps and services are used.",
            "infoTitle": "What information is stored?",
            "description3": "Posthog receives general web and app statistics. None of this can be used to identify the users. Vince only uses cookies for analytical purposes to develop our products to better serve our users' needs, and not for marketing purposes."
        },
        "privacyPolicy": {
            "title": "Privacy Policy",
            "customerPortal": "Customer Portal",
            "sections": [
                {
                    "title": "1. Who We Are",
                    "content": "This Privacy Policy applies to the Vince Live platform (\"Vince Live\") and to the companion VXL Live Excel add-in (the \"Add-in\") for Microsoft 365 (together, the \"Service\").\nThe Service is operated by Vince AS (Org. no. 896 890 042), a company registered in Norway with headquarters at Riddervolds gate 4, 0256 Oslo, Norway.\nOur website is {website}.\nWe act as controller for account-level and service-related personal data, and as processor for personal data that customer organizations process through workflows on our platform.\nFor privacy-related inquiries or requests, please contact us through our {customerPortal} or by email at {email}. If applicable, you may also contact our Data Protection Officer (DPO) through the same portal."
                },
                {
                    "title": "2. Roles in Processing",
                    "content": "When we provide the services, we act as controller for account, authentication, log, and analytics data.\nFor workflow data, we act as processor and handle personal data only on instructions from customer organizations, which are responsible for providing notices and ensuring a lawful basis.\nProcessing of personal data on behalf of customer organizations is governed by our Terms and Conditions and Data Processing Agreement (DPA), which apply to those contractual relationships. This Privacy Policy applies only to processing where we act as controller."
                },
                {
                    "title": "3. Categories of Personal Data We Process (as Controller)",
                    "content": "We process the following categories of personal data:",
                    "items": [
                        "Account data: name, email, organization membership, and role",
                        "Authentication data: credentials, tokens, and MFA methods",
                        "Identity data from Microsoft Entra ID: unique identifiers and profile data received when you sign in with your Microsoft work or school account",
                        "Technical data: IP address, device or browser information, and session identifiers",
                        "Service logs: system logs, error logs, and audit/activity logs (also visible to customer administrators)",
                        "Communications data: contact information used for operational messaging",
                        "Analytics data (opt-in): usage metrics and error reports"
                    ],
                    "footer": "Billing data is handled separately by contract and not through the platform.\nWe do not sell or rent personal data. It is shared only with sub-processors as described in this policy, or where required by law."
                },
                {
                    "title": "4. Purposes and Legal Basis (as Controller)",
                    "content": "We process personal data only where there is a lawful basis under the GDPR:",
                    "items": [
                        "Contract performance - managing user accounts, authenticating users, operating the Services, and keeping necessary activity logs",
                        "Legitimate interests - services monitoring, operational messaging, and security",
                        "Consent - analytics (opt-in; for service performance and usability analysis, excluding any Customer Data)",
                        "Legal obligations - compliance with statutory requirements"
                    ]
                },
                {
                    "title": "5. Workflow Data (Processor Role)",
                    "content": "Customer organizations may configure workflows that include personal data. In these cases, the customer is the controller, and we act only as processor. We process workflow data solely as needed to provide, secure, or support the services."
                },
                {
                    "title": "6. Sub-Processors",
                    "content": "We use GDPR-compliant sub-processors, all hosted in the EU/EEA:",
                    "items": [
                        "Amazon Web Services (AWS) - hosting and infrastructure",
                        "Twilio / SendGrid - SMS and email delivery",
                        "PostHog - analytics (opt-in)",
                        "Sentry - error tracking"
                    ]
                },
                {
                    "title": "7. Data Subject Rights (as Controller)",
                    "content": "You have the rights provided under Articles 15-22 GDPR, including access, rectification, erasure, restriction, portability, objection, and withdrawal of consent.\nYou also have the right to lodge a complaint with the Norwegian Data Protection Authority (Datatilsynet) under Article 77 GDPR. Information about how to contact Datatilsynet is available at {datatilsynet}.\nSelf-service tools are available in the platform, or you can submit a request through our {customerPortal} or by emailing {email}. For workflow data where we act as processor, requests should be directed to the relevant customer organization."
                },
                {
                    "title": "8. Retention and Deletion",
                    "content": "Personal data is retained only as long as necessary to provide the service. Logs and activity data are kept for up to 90 days. After account closure, personal data is deleted within 90 days, unless longer retention is required by law."
                },
                {
                    "title": "9. Security",
                    "content": "We apply technical and organizational measures such as encryption of data at rest and in transit, strict access controls, and EU/EEA-based hosting on secure infrastructure."
                },
                {
                    "title": "10. International Transfers",
                    "content": "All hosting and sub-processing takes place within the EU/EEA. No international transfers of personal data occur."
                },
                {
                    "title": "11. Changes",
                    "content": "We may update this policy from time to time. Significant changes will be communicated via the platform or by email."
                },
                {
                    "title": "12. VXL Live Excel Add-in",
                    "content": "This section describes how personal data is processed when you use the VXL Live Excel add-in for Microsoft 365 (the \"Add-in\").",
                    "items": [
                        "The Add-in has permissions only to read and write the current workbook. It does not access other files, mailboxes, or services.",
                        "Data in the workbook that is sent to Vince Live as part of a workflow (which may include personal data) is treated as Workflow Data under Section 5.",
                        "The Add-in does not use workbook content for advertising or profiling, and does not sell or rent personal data."
                    ]
                },
                {
                    "title": "13. Contact",
                    "content": "Vince AS\nOrg. no. 896 890 042\nRiddervolds gate 4, 0256 Oslo, Norway\n{website}\n{customerPortal}\nLast updated: November 2025"
                }
            ]
        },
        "tableAndDataFormatting": "Table and data formatting",
        "department": "Department",
        "aiHelperLevel": "Vince Platform Knowledge Level",
        "aiHelperLevels": {
            "beginner": "Just Starting - Beginner",
            "intermediate": "Some Experience - Intermediate",
            "advanced": "Pretty Confident - Advanced",
            "expert": "I Use This all the Time - Expert"
        }
    },
    "security": {
        "accessManagement": "Access Management",
        "authenticationType": "Authentication Type",
        "forbidden": "Forbidden",
        "youDontHavePermission": "Sorry, you do not have permissions to access this resource. Contact your tenant admin regarding your permissions.",
        "apiClients": {
            "activateApiClients": "Do you want to activate the api client?",
            "active": "Active",
            "addApiClients": "Add API Clients",
            "apiClient": "API Client",
            "apiClientName": "Api Client Name",
            "createApiClients": "Create API Clients",
            "deactivateApiClients": "Do you want to deactivate the api client?",
            "description": "Description",
            "loadingApiClients": "Loading API Clients...",
            "name": "Name",
            "updatingApiClientsRoles": "Updating API Client roles..."
        },
        "roles": {
            "bulkAssign": {
                "showSelectedOnly": "Show only selected",
                "hiddenByPermission": "{count} user(s) are hidden because you do not have permission to edit them.",
                "button": "Assign users",
                "title": "Assign users to {roleName}",
                "subtitle": "{count} user(s) currently have this role.",

                "modes": {
                    "add": "Add this role",
                    "remove": "Remove this role",
                    "replace": "Replace all roles with this one"
                },
                "replaceWarning": "{count} selected user(s) will lose their other roles.",
                "replaceConfirmHeader": "Replace all roles?",
                "replaceConfirmMessage": "{count} selected user(s) will lose every other role they hold. This cannot be undone.",
                "searchPlaceholder": "Search users…",
                "selectShown": "Select visible",
                "selectMembers": "Select with role",
                "selectedCount": "{count} user(s) selected",
                "clearSelection": "Clear selection",
                "alreadyAssigned": "Has role",
                "noUsers": "No users found",
                "apply": {
                    "add": "Assign to {count} users",
                    "remove": "Remove from {count} users",
                    "replace": "Replace roles for {count} users"
                },
                "applying": "Updating {done}/{total}…",
                "success": "{count} user(s) updated",
                "partialFailure": "{updated} updated, {failed} failed — failed users kept selected for retry"
            },
            "header": "Update roles",
            "addRole": "Add Role",
            "roleName": "Role Name",
            "placeholder": "Select Roles",
            "newRole": "New Role",
            "inactive": "Inactive",
            "active": "Active",
            "numberOfUsers": "Number of users",
            "numberOfPermissions": "Number of permissions",
            "externalId": "External ID",
            "externalIdPlaceholder": "IdP group ID (e.g. Microsoft Entra group Object ID)",
            "externalIdHint": "Link this role to an identity provider group for SCIM provisioning.",
            "table": {
                "app": "App",
                "resource": "Resource",
                "resourceName": "Resource Name",
                "addPermissions": "Add Permissions",
                "selectApp": "Select App",
                "selectResource": "Select Resource",
                "selectResourceName": "Select Resource Name",
                "selectPermission": "Select Permission",
                "permission": "Permission",
                "resourceNameNotAvailable": "The name of this resource was not accessible."
            },
            "messages": {
                "nameRequired": "Role name is required.",
                "descriptionRequired": "Description is required.",
                "appRequired": "Application is required.",
                "resourceRequired": "Resource is required.",
                "resourceNameRequired": "Resource name is required.",
                "actionRequired": "Action is required.",
                "success": "Role saved successfully.",
                "deleteRoleConfirmation": "Are you sure you want to delete the role {roleName}?",
                "deleteRoleSuccess": "Role deleted successfully.",
                "activateSuccess": "Role activated successfully!",
                "deactivateSuccess": "Role deactivated successfully!"
            }
        },
        "users": {
            "addUser": "Add User",
            "lastActive": "Last Active",
            "manageUser": "Manage User",
            "deactivateUser": "Deactivate User",
            "deactivateUserConfirm": "Do you want to deactivate this user?",
            "deactivateSuccessMessage": "User has been deactivated successfully",
            "activateUser": "Activate User",
            "activateUserConfirm": "Do you want to activate this user?",
            "activateSuccessMessage": "User has been activated successfully",
            "resendInvite": "Resend Invite",
            "resendInviteSuccessMessage": "Invite has been sent to the user successfully",
            "userType": "User Type",
            "groupNotFound": "Group not found",
            "permissions": {
                "VINCE_LIVE_ADMIN": "Live Admin",
                "VinceLiveAdmin": "Live Admin",
                "VINCE_LIVE_USER": "Live User",
                "VinceLiveUser": "Live User",
                "TENANT_ADMIN": "Admin",
                "TenantAdmin": "Admin",
                "TENANT_USER": "User",
                "TenantUser": "User"
            },
            "activeUsers": "{used}/{total} Active Users on your tenant plan.",
            "abovePlan": "You are above your plan, costs will be added per user.",
            "upgradePlanLink": "Upgrade your plan"
        }
    },
    "signIn": {
        "backToSignIn": "Back to Log In",
        "forgotPassword": "Forgot Password?",
        "forgotPasswordInstruction": "You will receive an email with a code to reset your password",
        "invalidPassword": "! Incorrect password",
        "login": "Log in",
        "loginMicrosoft": "Log in with Microsoft",
        "loginOkta": "Log in with Okta",
        "preparingVince": "Preparing your Vince experience..",
        "resetPassword": "Reset Password",
        "signinTo": "Sign in to {tenant}",
        "userNotFound": "! Oops, email not found. Please type in a registered email or contact support",
        "confirmationCodeRequired": "Confirmation code required",
        "passwordCriteriaMismatch": "! Password not matching the criteria",
        "invalidConfirmationCode": "Invalid verification code provided, please try again.",
        "attemptLimitExceeded": "Attempt limit exceeded, please try after some time.",
        "confirmationCode": "Confirmation code",
        "confirmationCodeInstruction": "Confirmation code has been sent to your email address.",
        "newPassword": "New Password",
        "newPasswordInstruction": "* Password must be at least 8 characters long, it must contain atleast one uppercase letter, one lowercase letter and a number",
        "invalidParameter": "Error in resetting password, contact support for further assistance",
        "enterValidEmail": "Please enter a valid email address",
        "userDisabled": "User is disabled, please contact support",
        "selectSsoProvider": "Select SSO Provider",
        "processingSso": "Processing SSO sign-in....",
        "ssoAuthFailed": "Authentication failed. Please try again.",
        "externalAuthRedirecting": "Redirecting...",
        "externalAuthCompleted": "Authentication completed. You can close this window.",
        "externalAuthFailed": "Authentication failed. You can close this window and try again.",
        "verifyIdentity": "Verify your identity",
        "smsMfaInstruction": "A verification code has been sent to your phone. Enter it below to continue.",
        "smsCode": "Verification code",
        "verify": "Verify",
        "smsCodeRequired": "Verification code is required",
        "invalidSmsCode": "Invalid verification code, please try again."
    },
    "tables": {
        "columns": "Columns",
        "copy": "Copy table",
        "copyPrefix": "Copy of ",
        "createdBy": "Created by",
        "emptyFilteredText": "There are no records matching your request.",
        "noEntitiesMessage": "No entity in this tenant's workspace",
        "createTable": "Create Table",
        "delete": "Delete table",
        "deleteConfirmation": "Are you sure that you want to delete table {tableName}? \nThe deletion process may take up to 6 hours. \nDuring this time, the table will remain in \n\"Deleting in progress...\" status",
        "deleteData": "Delete content",
        "deleteItem": "Delete table",
        "deletingInProgress": "Deleting in progress...",
        "deleteTableSuccess": "Table deleted successfully",
        "edit": "Edit table",
        "validateConnection": "Validate Connection",
        "importAPIs": "Import API's",
        "issueMTLSCert": "Issue MTLS Cert",
        "editConnection": "Edit",
        "deleteConnection": "Delete",
        "form": {
            "addColumnButton": "Add column",
            "columnAliasNameField": "Display name",
            "columnNameField": "Name",
            "dataTypeField": "Data type",
            "linkField": "Link",
            "linkTextField": "Link text",
            "primaryKeyField": "Primary key",
            "validations": {
                "duplicateColumnNamesError": "Duplicate column names found",
                "emptyColumnNameError": "Name cannot be blank",
                "emptyColumnTitleError": "Display name cannot be blank"
            },
            "enforceSchema": "Enforce data types",
            "advancedConfiguration": "Advanced configuration",
            "name": "Name *",
            "displayName": "Display Name *",
            "type": "Type *",
            "key": "Primary key",
            "advanced": "Advanced"
        },
        "modifiedBy": "Modified by",
        "new": "Create new table",
        "rows": "Rows",
        "showColumnConfig": "Columns info",
        "showData": "Show data",
        "tableConfig": "Table configuration",
        "tableName": "Table name",
        "title": "Table Management",
        "truncateConfirmation": "Are you sure that you want to delete all rows in table {tableName}",
        "truncateItem": "Truncate table",
        "truncateTableSuccess": "Table data deleted successfully",
        "updateType": "Update type",
        "updateTypes": {
            "APPEND": "Append",
            "REPLACE": "Replace",
            "UPSERT": "Upsert"
        },
        "upload": "Upload excel",
        "uploadExcel": "Upload excel",
        "uploadSuccess": "Successfully inserted {count} rows, it might take a few seconds to reflect in the table",
        "basicTypes": "Basic types",
        "string": "Text",
        "number": "Number",
        "integer": "Integer",
        "boolean": "Boolean",
        "dateTypes": "Date types",
        "iso-date-time": "ISO Date Time",
        "m3-date": "M3 Date",
        "specialTypes": "Special types",
        "compute-expression": "Computed",
        "otherTypes": "Other types",
        "email": "Email",
        "uuid": "UUID",
        "ipv4": "IP v4",
        "array": "Array",
        "object": "Object",
        "deleteRowMessage": "Are you sure you want to delete the selected rows?",
        "deleteRowSuccess": "Selected rows deleted. Changes may take a moment to appear.",
        "deleteRowButtonLabel": "Delete ({selectedRows} rows)",
        "saveSuccess": "Table configuration saved successfully."
    },
    "tags": {
        "addTag": "Add Tag",
        "editTag": "Edit Tag",
        "createTag": "Create Tag",
        "duplicateKey": "A tag with this name already exists",
        "placeholder": "Tags are key-value pairs which user can attach to entities for filtering data and controlling access in Vince Platform",
        "noTagsApplied": "No tags applied for this user",
        "confirmRemoveTag": "Are you sure you want to remove the tag?",
        "tagName": "Tag Name",
        "tagValue": "Value",
        "nameOfTag": "Name of Tag",
        "valueKey": "Value Key"
    },
    "users": {
        "bulkTag": {
            "button": "Set tag for users",
            "title": "Set tag for users",
            "subtitle": "Select a tag, then set a value for each user.",
            "tagName": "Tag name",
            "tagNamePlaceholder": "Select an existing tag or enter a new one",
            "hint": "Select the users to tag, then give each one its value. Other existing tags are kept.",
            "hiddenByPermission": "{count} user(s) are hidden because you do not have permission to edit them.",
            "searchPlaceholder": "Search users…",
            "fillPlaceholder": "Value for visible users…",
            "fill": "Apply",
            "selectAll": "Select all",
            "selectedCount": "{count} user(s) selected",
            "missingValue": "{count} without a value",
            "unchanged": "{count} unchanged",
            "showSelectedOnly": "Show selected",
            "clearValues": "Clear values",
            "valuePlaceholder": "value",
            "noUsers": "No users found",
            "apply": "Apply to {count} users",
            "applying": "Updating {done}/{total}…",
            "success": "{count} user(s) updated",
            "partialFailure": "{updated} updated, {failed} failed — failed rows kept for retry"
        },
        "show": {
            "ALL": "All",
            "ACTIVE": "Active",
            "DEACTIVATED": "Deactivated"
        },
        "title": "Users",
        "addRoles": "Add Roles",
        "addUser": "Add user",
        "newUser": "New user",
        "userFields": {
            "lastActive": "Last active",
            "m3userId": "M3 User Id",
            "identityProvider": "Sign-in method"
        },
        "identityProviders": {
            "SSO": "SSO",
            "MANUAL": "Manual"
        },
        "edit": "Edit",
        "personalInfo": "Personal Information",
        "saveSuccess": "User saved successfully",
        "saveError": "Error saving user",
        "userNotFound": "User not found",
        "loadError": "Error loading user data",
        "selectRole": "Select a role",
        "assignRolesToUser": "Add this user to roles",
        "assignTagsToUser": "Assign tags to this user",
        "validation": {
            "keyRequired": "Key is required",
            "duplicateTagKey": "Tag key \"{value}\" already exists",
            "valueEmpty": "Value cannot be empty",
            "valueRequired": "At least one value is required",
            "singleValueAllowed": "Only one value is allowed",
            "firstNameRequired": "First name is required",
            "firstNameMinLength": "First name must be at least 2 characters",
            "firstNameMaxLength": "First name must not exceed 50 characters",
            "lastNameRequired": "Last name is required",
            "lastNameMinLength": "Last name must be at least 2 characters",
            "emailRequired": "Email is required",
            "emailInvalid": "Please enter a valid email",
            "emailInUse": "This email is already in use",
            "permissionRequired": "Permission is required"
        },
        "license": {
            "userLimitMessage": "Users on your tenant plan"
        }
    },
    "roles": {
        "addRole": "Add Role",
        "createRole": "Create Role",
        "placeholder": "Roles are something to give permissions to view or edit dashboards, workflows or tables",
        "noRolesApplied": "No roles applied for this user",
        "confirmRemoveRole": "Are you sure you want to remove the role '{roleName}' from this user?"
    },
    "apiClients": {
        "apiClientName": "API Client Name",
        "description": "Description",
        "active": "Active",
        "action": "Action",
        "addApiClient": "Add API Client",
        "addToRolesTooltip": "Add this API-Client to roles",
        "messages": {
            "deleteAPIClientConfirmation": "Are you sure you want to delete the API Client '{apiClientName}'?",
            "deleteAPIClientSuccess": "API Client deleted successfully.",
            "deactivateAPIClientConfirmation": "Do you want to deactivate the API Client '{apiClientName}'?",
            "apiClientNameRequired": "Client name is required",
            "success": "API Client saved successfully!",
            "activateSuccess": "API Client activated successfully!",
            "deactivateSuccess": "API Client deactivated successfully!",
            "apiClientNameInvalid": "Name may only contain alphanumeric characters, spaces, and the following: +=,.@-"
        },
        "name": "Name",
        "label": "Label",
        "roles": "Roles",
        "clientId": "API Client ID",
        "clientSecret": "API Client Secret",
        "newAPIClient": "New API Client",
        "editAPIClient": "Edit API Client"
    },
    "webhooks": {
        "activateSuccess": "Webhook activated successfully!",
        "deactivateSuccess": "Webhook deactivated successfully!",
        "description": "Description",
        "invalidWorkflow": "Invalid workflow",
        "messages": {
            "copied": "Webhook copied to clipboard!",
            "copyError": "Error copying webhook!",
            "deleteWebhookConfirmation": "Do you want to delete webhook {webhookName}?",
            "deleteWebhookSuccess": "Webhook deleted successfully!",
            "success": "Webhook saved successfully!",
            "webhookNameRequired": "Webhook name is required",
            "workflowRequired": "Workflow is required"
        },
        "newWebhook": "New Webhook",
        "title": "Webhooks",
        "webhookDetails": "Webhook details",
        "webhookId": "Webhook Id",
        "webhookName": "Webhook Name",
        "workflow": "Workflow",
        "username": "Username",
        "password": "Password",
        "token": "Token"
    },
    "variables": {
        "addVariables": "Add Variable",
        "editVariables": "Edit Variable",
        "tooltip": "By checking secure, your variable will store the data encrypted and cannot be viewed after creation.",
        "messages": {
            "success": "Variable saved successfully!",
            "deleteVariableConfirmation": "Do you want to delete the variable {variableName}?",
            "variableNameRequired": "Variable name is required",
            "variableValueRequired": "Variable value is required",
            "deleteSuccess": "Variable deleted successfully"
        },
        "name": "Name",
        "secure": "Secure",
        "title": "Variables",
        "value": "Value",
        "newVariable": "New Variable",
        "unsecure": "Unsecure"
    },
    "company": {
        "headers": {
            "settings": "Company Settings",
            "identityProviders": "Identity Providers",
            "identityProvidersName": "Identity Providers Name",
            "enterpriseIntegrations": "Enterprise Integrations",
            "companyInformation": "Company Information"
        },
        "tabs": {
            "information": "Information",
            "scim": "Scim",
            "singlesignon": "Single Sign-On"
        },
        "labels": {
            "identityProvider": "Identity Provider",
            "scimUrl": "SCIM URL",
            "token": "Token",
            "enforceSso": "Enforce SSO",
            "identityProviderName": "Identity Provider Name",
            "issuerUrl": "Issuer URL",
            "clientId": "Client ID",
            "clientSecret": "Client Secret",
            "companyName": "Company Name",
            "tenantId": "Tenant ID",
            "industry": "Industry",
            "selectIndustry": "Select industry",
            "dedicatedIpAddresses": "Dedicated IP Addresses",
            "dedicatedIpWhitelistInfo": "Whitelist these IP addresses to allow traffic from your dedicated proxy"
        },
        "placeholders": {
            "selectIdentityProvider": "Select Identity Provider",
            "scimUrl": "SCIM URL",
            "token": "Token",
            "identityProviderName": "Identity Provider Name",
            "issuerUrl": "Issuer URL",
            "clientId": "Client ID",
            "clientSecret": "Client Secret"
        },
        "buttons": {
            "addIdentityProvider": "Add Identity Provider",
            "regenerateToken": "Regenerate Token"
        },
        "messages": {
            "identityProviderDeleted": "Identity Provider deleted successfully.",
            "deleteConfirmation": "Are you sure you want to delete the identity provider '{providerName}'?",
            "configuringIdentityProvider": "Identity Provider is being configured. This may take a moment.",
            "updatedIdentityProvider": "Identity Provider updated successfully.",
            "ssoUpdated": "SSO settings updated successfully.",
            "enforceSsoDisabledTooltip": "Add an identity provider to enable SSO enforcement.",
            "tokenGenerated": "SCIM token generated successfully.",
            "copied": "Copied to clipboard.",
            "copyError": "Failed to copy to clipboard.",
            "industryUpdated": "Industry updated successfully.",
            "industryUpdateError": "Failed to update industry."
        },
        "validation": {
            "identityProviderRequired": "Identity Provider is required.",
            "issuerUrlRequired": "Issuer URL is required.",
            "clientIdRequired": "Client ID is required.",
            "clientSecretRequired": "Client Secret is required."
        },
        "tooltips": {
            "tokenInfo": "If you lose your token, you cannot retrieve it. Instead, you must create a new one."
        }
    },
    "resourceType": {
        "META": "Custom table (meta)"
    },
    "direction": {
        "horizontal": "Horizontal",
        "vertical": "Vertical"
    },
    "buttonType": {
        "PRIMARY": "Primary",
        "SECONDARY": "Secondary",
        "OUTLINE_PRIMARY": "Primary outlined",
        "OUTLINE_SECONDARY": "Secondary outlined",
        "OUTLINE_DANGER": "Danger outlined",
        "LINK_PRIMARY": "Primary linked",
        "LINK_DANGER": "Danger linked"
    },
    "formBuilder": {
        "dataField": "Data field",
        "sourceTableColumns": "Columns",
        "sourceTable": "Table",
        "formCodeHeader": "Form code",
        "source": "Source type",
        "sourceId": "Source",
        "defineInputs": "Define form data",
        "emptyFormLabel": "New form",
        "preview": "Preview",
        "showCode": "Show code",
        "selectElement": "Select element to configure its properties",
        "elementDetails": "Element details",
        "elementsPaletteHeader": "Available elements",
        "formCanvasHeader": "Form",
        "emptyFormDescription": "Some form description if needed",
        "previewHeader": "Form preview",
        "formDataHeader": "Define form data",
        "visibilityRuleTypeLabel": "Type",
        "comparison": "Comparison",
        "value": "Value",
        "field": "Field",
        "visibilityRuleType": {
            "CONTEXT": "User context",
            "FIELD": "Field"
        },
        "fillContext": {
            "nickname": "Nickname",
            "lastName": "Last name",
            "firstName": "First name",
            "tags": "Tags",
            "email": "Email",
            "groups": "Groups"
        },
        "elements": {
            "HEADER": {
                "defaultText": "Header",
                "label": "Header",
                "description": "Various headers",
                "editor": {
                    "label": "Label",
                    "size": "Size"
                }
            },
            "TEXT": {
                "defaultText": "Text...",
                "label": "Text",
                "description": "Informative text",
                "size": {
                    "SUB": "Small",
                    "MAIN": "Normal"
                },
                "editor": {
                    "label": "Text",
                    "size": "Text size"
                }
            },
            "TEXT_INPUT": {
                "defaultText": "Text...",
                "label": "Text input",
                "description": "Input that allows to enter any single-line text",
                "editor": {
                    "label": "Label",
                    "readonly": "Read only (not editable - can be used just for displaying value)"
                }
            },
            "NUMBER_INPUT": {
                "defaultText": "Number...",
                "label": "Number input",
                "description": "Input that allows to enter numeric values",
                "editor": {
                    "label": "Label",
                    "readonly": "Read only (not editable - can be used just for displaying value)",
                    "minValue": "Minimal value",
                    "maxValue": "Maximal value",
                    "prefix": "Prefix",
                    "showFractionDigits": "Show fraction digits"
                }
            },
            "DIVIDER": {
                "label": "Divider",
                "description": "Divider to separate blocks"
            },
            "CONTAINER": {
                "label": "Container",
                "description": "Container for other elements",
                "editor": {
                    "direction": "Direction",
                    "visibilityRules": "Visibility rules"
                }
            },
            "BUTTON": {
                "label": "Button",
                "description": "Clickable element to execute actions with form data",
                "defaultLabel": "Click me",
                "editor": {
                    "action": "Action",
                    "label": "Label",
                    "buttonType": "Button style"
                }
            },
            "DATE_INPUT": {
                "label": "Date input",
                "defaultLabel": "Date",
                "description": "Input that allows to enter any date/date with time",
                "editor": {
                    "label": "Label",
                    "withTime": "Include time part",
                    "readonly": "Read only (not editable - can be used just for displaying value)"
                }
            },
            "CHECKBOX": {
                "label": "Checkbox",
                "defaultLabel": "Checkbox",
                "description": "Checkbox with 2 values",
                "editor": {
                    "label": "Label",
                    "trueValue": "Value to be used for 'checked' state",
                    "falseValue": "Value to be used for 'unchecked' state",
                    "readonly": "Read only (not editable - can be used just for displaying value)"
                }
            },
            "SELECT_INPUT": {
                "label": "Select input",
                "defaultLabel": "Select",
                "description": "Input that allows to select one element from a list",
                "editor": {
                    "label": "Label",
                    "options": "Options",
                    "optionValue": "Value",
                    "optionLabel": "Label",
                    "readonly": "Read only (not editable - can be used just for displaying value)"
                }
            }
        }
    },
    "auditLogs": {
        "title": "Audit Logs",
        "selectEntity": "Select Entity",
        "startDate": "Start Date",
        "endDate": "End Date",
        "apply": "Apply",
        "reset": "Reset",
        "entity": {
            "users": "Users",
            "roles": "Roles",
            "workflows": "Workflows",
            "connections": "Connections",
            "environments": "Environments",
            "application": "Application",
            "appVersion": "App Version",
            "appResource": "App Resource",
            "roleAssignment": "Role Assignment",
            "mcpServer": "MCP Server",
            "tenantPrompt": "Tenant Prompt"
        },
        "entityGroup": {
            "platform": "Platform",
            "aiApps": "AI Apps"
        },
        "table": {
            "userName": "User Name",
            "timeStamp": "Timestamp",
            "entity": "Entity",
            "entityName": "Name",
            "action": "Action",
            "details": "Details"
        },
        "expansion": {
            "user": "User:",
            "dateModified": "Date Modified:",
            "changed": "Changed:",
            "viewChanges": "View Changes"
        }
    },
    "schedules": {
        "nextExecution": "Next Execution",
        "runs": "Schedule Runs",
        "status": "Status",
        "invalidExpression": "Invalid expression",
        "expired": "Expired",
        "active": "Active",
        "disabled": "Disabled",
        "messages": {
            "confirmDeleteMessage": "Are you sure you want to delete this schedule?",
            "confirmDeleteHeader": "Delete Schedule",
            "deleteSuccess": "Schedule deleted successfully",
            "disableSuccess": "Schedule disabled successfully",
            "enableSuccess": "Schedule enabled successfully"
        }
    },
    "filters": {
        "tag": "Tag: {tag}",
        "field": "Field: {field}",
        "context": "Context: {context}",
        "relativeDates": {
            "0_DAY_START": "Start of today",
            "1_DAY_START": "Start of tomorrow",
            "-1_DAY_START": "Start of yesterday",
            "0_WEEK_START": "Start of this week",
            "1_WEEK_START": "Start of next week",
            "-1_WEEK_START": "Start of last week",
            "0_MONTH_START": "Start of this month",
            "1_MONTH_START": "Start of next month",
            "-1_MONTH_START": "Start of last month",
            "0_QUARTER_START": "Start of this quarter",
            "1_QUARTER_START": "Start of next quarter",
            "-1_QUARTER_START": "Start of last quarter",
            "0_YEAR_START": "Start of this year",
            "1_YEAR_START": "Start of next year",
            "-1_YEAR_START": "Start of last year"
        }
    }
}
